import React, { useContext, useEffect, useRef, useState } from "react";

import ReactECharts from "echarts-for-react";
import apiClient from "../../ApiClient";
import { AppSettings } from "../../config/app-settings";
import DynamicCard from "../../components/DynamicCard";

const requiredParams = [
  "AK PARTİ",
  "CHP",
  "MHP",
  "DEM PARTI",
  "İYİ PARTİ",
  "TİP",
  "YRP",
];

const requiredParamsColors = [
  { parametre: "AK PARTİ", color: "#f7981a" },
  { parametre: "MHP", color: "#2dcc33" },
  { parametre: "DEM PARTI", color: "#660099" },
  { parametre: "İYİ PARTİ", color: "#ffeb3b" },
  { parametre: "TİP", color: "#8B0000" },
  { parametre: "YRP", color: "#964B00" },
  { parametre: "CHP", color: "#ed1b25" },
];

export default function IlceGeneliPartilerinOyDegisimiBar({
  title,
  city,
  district,
  type,
  filter,
}) {
  const context = useContext(AppSettings);

  const chartRef = useRef();

  const [winner, setWinner] = useState(null);
  const [chartOption, myChartOption] = useState(null);

  const [data] = useState([["Income", "Country", "Year"]]);
  const [chartData, setChartData] = useState(null);

  const [yearData, setYearData] = useState([]);
  const [titleData, setTitleData] = useState([]);
  const [optionsData, setOptionsData] = useState([]);

  async function fetchData() {
    myChartOption(null);

    try {
      const response = await apiClient.customPost(
        `/query/preview`,
        {
          chart: 1,
          page_id: 23,
          title: type || "stratejimerkezi-secim-ilce",
          type: type || "stratejimerkezi-secim-ilce",
          description: "",
          customer: null,
          status: true,
          order: 1,
          connection_type: "local",
          sql: {
            column: [
              {
                key: "TARIH",
                value: "select",
              },
              {
                key: "ALT-KATEGORI-2",
                value: "select",
              },
              {
                key: "PARAMETRE",
                value: "select",
              },
              {
                key: "DEGER",
                value: "sum",
              },
            ],
            condition: [
              city
                ? {
                    key: "SEHIR",
                    value: context.removeTurkishCharacters(city).toUpperCase(),
                    operator: "=",
                    type: "and",
                  }
                : null,
              district
                ? {
                    key: "ILCE",
                    value: context
                      .removeTurkishCharacters(district)
                      .toUpperCase(),
                    operator: "=",
                    type: "and",
                  }
                : null,
              filter || null,
            ].filter((item) => item !== null),
            group: [],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response && response.length !== 0) {
        // 1. Veriyi requiredParams içinde olan parametrelere göre filtrele
        let filteredData = response.filter((item) =>
          requiredParams.includes(item.parametre)
        );

        const groupedData = {};
        filteredData.forEach((item) => {
          const key = item[filter ? "tarih" : "alt-kategori-2"];
          if (!groupedData[key]) groupedData[key] = {};
          groupedData[key][item.parametre] = item;
        });

        // 3. Eksik parametreleri ekle
        Object.keys(groupedData).forEach((category) => {
          requiredParams.forEach((param) => {
            if (!groupedData[category][param]) {
              groupedData[category][param] = {
                tarih: "",
                [filter ? "tarih" : "alt-kategori-2"]: category,
                parametre: param,
                deger_sum: 0,
              };
            }
          });
        });

        // 4. Objeyi düz listeye çevirip tarihe göre sırala
        const sortedData = Object.values(groupedData)
          .flatMap((category) => Object.values(category))
          .sort((a, b) => {
            const yearA = a.tarih ? parseInt(a.tarih.split("-")[0]) : 0;
            const yearB = b.tarih ? parseInt(b.tarih.split("-")[0]) : 0;
            return yearA - yearB;
          });

        // 5. Formatlama
        const formattedData = [
          ["Income", "Country", "Year"],
          ...sortedData.map((item) => [
            item.deger_sum,
            item.parametre,
            item[filter ? "tarih" : "alt-kategori-2"],
          ]),
        ];

        // Winner
        const maxTarih = filteredData.reduce(
          (max, item) => (item.tarih > max ? item.tarih : max),
          filteredData[0].tarih
        );

        const maxItem = !type
          ? filteredData
              .filter(
                (item) =>
                  item.tarih === maxTarih &&
                  !filter &&
                  item["alt-kategori-2"] ===
                    "2024 BELEDİYE BAŞKANLIĞI YEREL SEÇİMLERİ"
              )
              .reduce((max, item) =>
                item.deger_sum > max.deger_sum ? item : max
              )
          : null;

        const parametre = !type ? maxItem.parametre : null;

        //-*-**-*-*--**-

        const order = [
          "AK PARTİ",
          "CHP",
          "MHP",
          "DEM PARTI",
          "İYİ PARTİ",
          "TİP",
          "YRP",
        ];

        const filteredResponse = response
          .filter((item) => order.includes(item.parametre))
          .sort(
            (a, b) => order.indexOf(a.parametre) - order.indexOf(b.parametre)
          );

        const inputArray = filteredResponse.sort(
          (a, b) =>
            parseInt(a.tarih.split("-")[0]) - parseInt(b.tarih.split("-")[0])
        );

        const years = [
          ...new Set(
            inputArray.map((item) => parseInt(item.tarih.split("-")[0]))
          ),
        ].sort((a, b) => a - b);

        const parameters = [
          ...new Set(inputArray.map((item) => item.parametre)),
        ];

        const formattedYears = years.map((year) => `${year}-`);

        const chartData = years.map((year) => {
          // Her yıl için ilgili veriyi filtrele
          const filteredData = inputArray.filter(
            (item) => parseInt(item.tarih.split("-")[0]) === year
          );

          // O yılın chart verisini oluştur
          return {
            title: {
              text: `${year} - ` + context?.t?.dagilim,
              textStyle: {
                color: context?.theme === "light" ? "#000" : "#fff",
              },
            },
            series: [
              {
                type: "bar",
                data: parameters.map((param) => {
                  const foundItem = filteredData.find(
                    (item) => item.parametre === param
                  );
                  const foundColor = requiredParamsColors.find(
                    (item) => item.parametre === param
                  );

                  return {
                    value: foundItem ? foundItem.deger_sum : 0,
                    itemStyle: {
                      color: foundColor?.color || "#ccc", // fallback renk
                    },
                  };
                }),
              },
            ],
          };
        });

        setYearData(formattedYears);
        setTitleData([...parameters]);
        setOptionsData(chartData);

        setWinner(parametre);
        myChartOption(chartData);
        // setChartData(formattedData);
      } else {
        myChartOption("none");
      }
    } catch (error) {
      console.error("Genel Data Error", error);
      myChartOption("none");
    }
  }

  useEffect(() => {
    if (city && district) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city, district]);

  // Chart
  const option = {
    baseOption: {
      timeline: {
        left: 0,
        right: 0,
        axisType: "category",
        autoPlay: true,
        playInterval: 3000,
        checkpointStyle: {
          borderColor: "#ffffff",
          color: "#ffffff",
        },
        lineStyle: {
          color: "white",
        },
        itemStyle: {
          color: "#ffffff",
        },
        data: yearData,
        label: {
          formatter: function (s) {
            return new Date(s).getFullYear();
          },
        },
      },
      tooltip: {},
      calculable: true,
      grid: {
        right: 10,
        left: 75,
        top: 70,
        bottom: 110,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              formatter: function (params) {
                return params.value.replace("\n", "");
              },
            },
          },
        },
      },
      xAxis: [
        {
          type: "category",
          axisLabel: {
            interval: 0,
            rotate: 45,
            textStyle: {
              color: context?.theme === "light" ? "#000" : "#fff",
            },
            formatter: function (value, index) {
              return type === "yas" || type === "ses-raporu"
                ? value
                : value.substring(0, 7) + "...";
            },
          },
          data: titleData,
          splitLine: { show: false },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "",
          axisLabel: {
            textStyle: {
              color: context?.theme === "light" ? "#000" : "#fff",
            },
          },
        },
      ],
      series: [
        {
          name: "",
          type: "bar",
        },
      ],
      visualMap: false,
    },
    options: optionsData,
  };

  return (
    <div className="position-relative">
      {chartOption && winner && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: "none",
            opacity: 0.4,
            background: requiredParamsColors.find(
              (item) => item.parametre === winner
            ).color,
          }}
        ></div>
      )}
      <DynamicCard
        item={{
          title: title,
        }}
        fullScreen={true}
        events={false}
        chart={
          chartOption ? (
            chartOption === "none" ? (
              <span className="d-block text-center">
                {context?.t?.no_data_available}
              </span>
            ) : (
              <ReactECharts
                option={option}
                ref={chartRef}
                className="w-100 h-100"
              />
            )
          ) : (
            <div className="spinner-border text-theme"></div>
          )
        }
      />
    </div>
  );
}
